var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSolicitacoes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4C3 2.89543 3.89543 2 5 2H14C15.1046 2 16 2.89543 16 4V16C16 17.1046 15.1046 18 14 18H5C3.89543 18 3 17.1046 3 16V4ZM5.16602 4H13.8327V5H5.16602V4ZM13.8327 6H5.16602V7H13.8327V6ZM5.16602 8H13.8327V9H5.16602V8ZM13.8327 10H5.16602V11H13.8327V10ZM5.16602 12H13.8327V13H5.16602V12ZM13.8327 14H5.16602V15H13.8327V14Z",
    fill: "#12A8EC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSolicitacoes);
export default __webpack_public_path__ + "static/media/icon-solicitacoes.46ba75116218fb9c0688935f3570bace.svg";
export { ForwardRef as ReactComponent };